import { BusinessServicesCardWithImage, SectionTitle } from '@/ui/index';

import Card from './Card';

import styles from './FixServices.module.scss';

const FixServices = ({ data }) => {
  const renderTopServices = (item, key) => {
    return <BusinessServicesCardWithImage data={item} key={key} />;
  };

  const renderBottomServices = (item, key) => {
    return <Card data={item} key={key} />;
  };

  const dataTop = data?.sections?.slice(0, 2);
  const dataBottom = data?.sections?.slice(2);

  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <SectionTitle titleModify={'title--largest'}>{data.title}</SectionTitle>
      <div className={styles.grid}>
        {dataTop?.map(renderTopServices)}
        {dataBottom?.map(renderBottomServices)}
      </div>
    </div>
  );
};

export default FixServices;
